import React from 'react';

const icons = {
    changeIcon: (function () {
        return (
        <svg width="21" height="21">
            <defs>
            </defs>
            <path fill="#ffffff"
                  d="M20.014,20.874 C19.565,20.874 19.200,20.509 19.200,20.060 L19.200,15.700 C17.389,18.708 14.120,20.736 10.352,20.736 C5.067,20.736 0.716,16.779 0.077,11.667 L1.661,11.667 C2.289,15.910 5.935,19.168 10.352,19.168 C13.735,19.168 16.659,17.250 18.130,14.450 L13.577,14.450 C13.127,14.450 12.763,14.086 12.763,13.636 C12.763,13.186 13.127,12.822 13.577,12.822 L19.995,12.822 C20.109,12.822 20.217,12.846 20.316,12.888 C20.616,13.008 20.829,13.299 20.829,13.642 L20.829,20.060 C20.829,20.509 20.464,20.874 20.014,20.874 ZM10.352,1.575 C6.911,1.575 3.936,3.554 2.491,6.433 L7.263,6.433 C7.713,6.433 8.077,6.797 8.077,7.247 C8.077,7.697 7.713,8.061 7.263,8.061 L0.845,8.061 C0.507,8.061 0.217,7.855 0.094,7.561 C0.045,7.464 0.011,7.359 0.011,7.241 L0.011,0.823 C0.011,0.374 0.376,0.009 0.826,0.009 C1.275,0.009 1.640,0.374 1.640,0.823 L1.640,4.770 C3.484,1.908 6.693,0.007 10.352,0.007 C15.636,0.007 19.988,3.965 20.626,9.076 L19.043,9.076 C18.415,4.834 14.769,1.575 10.352,1.575 Z"
            />
        </svg>
        )
    })(),
    deleteIcon: (function () {
        return (
        <svg width="20px" height="21px" viewBox="0 0 16 15">
            <path d="M14.5,3H14v12c0,0.552-0.448,1-1,1H2c-0.552,0-1-0.448-1-1V3H0.5C0.224,3,0,2.776,0,2.5
                  C0,2.224,0.224,2,0.5,2H2h3V0.5C5,0.224,5.224,0,5.5,0h4C9.776,0,10,0.224,10,0.5V2h3h1.5C14.776,2,15,2.224,15,2.5
        	C15,2.776,14.776,3,14.5,3z M9,1H6v1h3V1z M13,3h-0.5h-10H2v0.5v0.499v10.5C2,14.776,2.224,15,2.5,15h10c0.276,0,0.5-0.224,0.5-0.5
        	V4.001h0L13,3z M10,6.5h1v6h-1V6.5z M7,5.5h1v7H7V5.5z M4,6.5h1v6H4V6.5z" fill="#ffffff" />
        </svg>
        )
    })(),
    cropIcon: (function () {
        return (
        <svg width="21px" height="21px" viewBox="0 0 26 26">
            <path d="M23,23v-2h3v2H23z M20,5H8V3h14v23h-2V5z M6,21h12v2H4V0h2V21z M0,3h3v2H0V3z" fill="#ffffff"/>
        </svg>
        )
    })()
};

export default icons;


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/icons.jsx